export default __webpack_public_path__ + "static/media/S-logo.2fa4469e.PNG";